/*!
 * Validator v0.11.9 for Bootstrap 3, by @1000hz
 * Copyright 2017 Cina Saffary
 * Licensed under http://opensource.org/licenses/MIT
 *
 * https://github.com/1000hz/bootstrap-validator
 */

+(function ($) {
  "use strict";

  // VALIDATOR CLASS DEFINITION
  // ==========================

  function getValue($el) {
    return $el.is('[type="checkbox"]')
      ? $el.prop("checked")
      : $el.is('[type="radio"]')
        ? !!$('[name="' + $el.attr("name") + '"]:checked').length
        : $el.is("select[multiple]")
          ? ($el.val() || []).length
          : $el.val();
  }

  var Validator = function (element, options) {
    this.options = options;
    this.validators = $.extend({}, Validator.VALIDATORS, options.custom);
    this.$element = $(element);
    this.$btn = $('button[type="submit"], input[type="submit"]')
      .filter('[form="' + this.$element.attr("id") + '"]')
      .add(this.$element.find('input[type="submit"], button[type="submit"]'));

    this.update();

    this.$element.on(
      "input.bs.validator change.bs.validator focusout.bs.validator",
      $.proxy(this.onInput, this)
    );
    this.$element.on("submit.bs.validator", $.proxy(this.onSubmit, this));
    this.$element.on("reset.bs.validator", $.proxy(this.reset, this));

    this.$element.find("[data-match]").each(function () {
      var $this = $(this);
      var target = $this.attr("data-match");

      $(target).on("input.bs.validator", function (e) {
        getValue($this) && $this.trigger("input.bs.validator");
      });
    });

    // run validators for fields with values, but don't clobber server-side errors
    this.$inputs
      .filter(function () {
        return getValue($(this)) && !$(this).closest(".has-error").length;
      })
      .trigger("focusout");

    this.$element.attr("novalidate", true); // disable automatic native validation
  };

  Validator.VERSION = "0.11.9";

  Validator.INPUT_SELECTOR =
    ':input[required]:not([type="hidden"], [type="submit"], [type="reset"], [type="search"], button)';

  Validator.FOCUS_OFFSET = 20;

  Validator.DEFAULTS = {
    delay: 500,
    html: false,
    disable: true,
    focus: true,
    custom: {},
    errors: {
      match: "Does not match",
      minlength: "Not long enough",
    },
    feedback: {
      success: "glyphicon-ok",
      error: "glyphicon-remove",
    },
  };

  Validator.VALIDATORS = {
    native: function ($el) {
      var el = $el[0];
      if (el.checkValidity) {
        return (
          !el.checkValidity() &&
          !el.validity.valid &&
          (el.validationMessage || "error!")
        );
      }
    },
    match: function ($el) {
      var target = $el.attr("data-match");
      return $el.val() !== $(target).val() && Validator.DEFAULTS.errors.match;
    },
    minlength: function ($el) {
      var minlength = $el.attr("data-minlength");
      return (
        $el.val().length < minlength && Validator.DEFAULTS.errors.minlength
      );
    },
  };

  Validator.prototype.update = function () {
    var self = this;

    this.$inputs = this.$element
      .find(Validator.INPUT_SELECTOR)
      .add(this.$element.find('[data-validate="true"]'))
      .not(
        this.$element.find('[data-validate="false"]').each(function () {
          self.clearErrors($(this));
        })
      );

    this.toggleSubmit();

    return this;
  };

  Validator.prototype.onInput = function (e) {
    var self = this;
    var $el = $(e.target);
    var deferErrors = e.type !== "focusout";

    if (!this.$inputs.is($el)) return;

    this.validateInput($el, deferErrors).done(function () {
      self.toggleSubmit();
    });
  };

  Validator.prototype.validateInput = function ($el, deferErrors) {
    var value = getValue($el);
    var prevErrors = $el.data("bs.validator.errors");

    if ($el.is('[type="radio"]'))
      $el = this.$element.find('input[name="' + $el.attr("name") + '"]');

    var e = $.Event("validate.bs.validator", { relatedTarget: $el[0] });
    this.$element.trigger(e);
    if (e.isDefaultPrevented()) return;

    var self = this;

    return this.runValidators($el).done(function (errors) {
      $el.data("bs.validator.errors", errors);

      errors.length
        ? deferErrors
          ? self.defer($el, self.showErrors)
          : self.showErrors($el)
        : self.clearErrors($el);

      if (!prevErrors || errors.toString() !== prevErrors.toString()) {
        e = errors.length
          ? $.Event("invalid.bs.validator", {
            relatedTarget: $el[0],
            detail: errors,
          })
          : $.Event("valid.bs.validator", {
            relatedTarget: $el[0],
            detail: prevErrors,
          });

        self.$element.trigger(e);
      }

      self.toggleSubmit();

      self.$element.trigger(
        $.Event("validated.bs.validator", { relatedTarget: $el[0] })
      );
    });
  };

  Validator.prototype.runValidators = function ($el) {
    var errors = [];
    var deferred = $.Deferred();

    $el.data("bs.validator.deferred") &&
      $el.data("bs.validator.deferred").reject();
    $el.data("bs.validator.deferred", deferred);

    function getValidatorSpecificError(key) {
      return $el.attr("data-" + key + "-error");
    }

    function getValidityStateError() {
      var validity = $el[0].validity;
      return validity.typeMismatch
        ? $el.attr("data-type-error")
        : validity.patternMismatch
          ? $el.attr("data-pattern-error")
          : validity.stepMismatch
            ? $el.attr("data-step-error")
            : validity.rangeOverflow
              ? $el.attr("data-max-error")
              : validity.rangeUnderflow
                ? $el.attr("data-min-error")
                : validity.valueMissing
                  ? $el.attr("data-required-error")
                  : null;
    }

    function getGenericError() {
      return $el.attr("data-error");
    }

    function getErrorMessage(key) {
      return (
        getValidatorSpecificError(key) ||
        getValidityStateError() ||
        getGenericError()
      );
    }

    $.each(
      this.validators,
      $.proxy(function (key, validator) {
        var error = null;
        if (
          (getValue($el) || $el.attr("required")) &&
          ($el.attr("data-" + key) !== undefined || key == "native") &&
          (error = validator.call(this, $el))
        ) {
          error = getErrorMessage(key) || error;
          !~errors.indexOf(error) && errors.push(error);
        }
      }, this)
    );

    if (!errors.length && getValue($el) && $el.attr("data-remote")) {
      this.defer($el, function () {
        var data = {};
        data[$el.attr("name")] = getValue($el);
        $.get($el.attr("data-remote"), data)
          .fail(function (jqXHR, textStatus, error) {
            errors.push(getErrorMessage("remote") || error);
          })
          .always(function () {
            deferred.resolve(errors);
          });
      });
    } else deferred.resolve(errors);

    return deferred.promise();
  };

  Validator.prototype.validate = function () {
    var self = this;

    $.when(
      this.$inputs.map(function (el) {
        return self.validateInput($(this), false);
      })
    ).then(function () {
      self.toggleSubmit();
      self.focusError();
    });

    return this;
  };

  Validator.prototype.focusError = function () {
    if (!this.options.focus) return;

    var $input = this.$element.find(".has-error:first :input");
    if ($input.length === 0) return;

    $("html, body").animate(
      { scrollTop: $input.offset().top - Validator.FOCUS_OFFSET },
      250
    );
    $input.focus();
  };

  Validator.prototype.showErrors = function ($el) {
    var method = this.options.html ? "html" : "text";
    var errors = $el.data("bs.validator.errors");
    var $group = $el.closest(".form-group,.form-label-group,.custom-control");
    var $input = $group.find(
      ".form-control,.custom-control-input,.custom-select"
    );
    var $block = $group.find(".help-block");
    var $feedback = $group.find(".form-control-feedback");

    if (!errors.length) return;

    errors = $("<ul/>")
      .addClass("list-unstyled")
      .append(
        $.map(errors, function (error) {
          return $("<li/>")[method](error);
        })
      );

    $block.data("bs.validator.originalContent") === undefined &&
      $block.data("bs.validator.originalContent", $block.html());
    $block.empty().append(errors);
    $input.addClass("is-invalid");
    $input.removeClass("is-valid");
  };

  Validator.prototype.clearErrors = function ($el) {
    var $group = $el.closest(".form-group,.form-label-group,.custom-control");
    var $input = $group.find(
      ".form-control,.custom-control-input,.custom-select"
    );
    var $block = $group.find(".help-block");
    var $feedback = $group.find(".form-control-feedback");

    $block.html($block.data("bs.validator.originalContent"));
    $input.removeClass("is-invalid is-valid");

    getValue($el) && $input.addClass("is-valid");
  };

  Validator.prototype.hasErrors = function () {
    function fieldErrors() {
      return !!($(this).data("bs.validator.errors") || []).length;
    }

    return !!this.$inputs.filter(fieldErrors).length;
  };

  Validator.prototype.isIncomplete = function () {
    function fieldIncomplete() {
      var value = getValue($(this));
      return !(typeof value == "string" ? $.trim(value) : value);
    }

    return !!this.$inputs.filter("[required]").filter(fieldIncomplete).length;
  };

  Validator.prototype.onSubmit = function (e) {
    this.validate();
    if (this.isIncomplete() || this.hasErrors()) e.preventDefault();
  };

  Validator.prototype.toggleSubmit = function () {
    if (!this.options.disable) return;
    this.$btn.toggleClass("disabled", this.isIncomplete() || this.hasErrors());
    //this.$btn.attr("disabled", this.isIncomplete() || this.hasErrors());
  };

  Validator.prototype.defer = function ($el, callback) {
    callback = $.proxy(callback, this, $el);
    if (!this.options.delay) return callback();
    window.clearTimeout($el.data("bs.validator.timeout"));
    $el.data(
      "bs.validator.timeout",
      window.setTimeout(callback, this.options.delay)
    );
  };

  Validator.prototype.reset = function () {
    this.$element
      .find(".form-control-feedback")
      .removeClass(this.options.feedback.error)
      .removeClass(this.options.feedback.success);

    this.$inputs
      .removeData(["bs.validator.errors", "bs.validator.deferred"])
      .each(function () {
        var $this = $(this);
        var timeout = $this.data("bs.validator.timeout");
        window.clearTimeout(timeout) &&
          $this.removeData("bs.validator.timeout");
      });

    this.$element.find(".help-block").each(function () {
      var $this = $(this);
      var originalContent = $this.data("bs.validator.originalContent");

      $this.removeData("bs.validator.originalContent").html(originalContent);
    });

    this.$btn.removeClass("disabled");
    this.$btn.attr("disabled", false);

    this.$element
      .find(".is-valid, .is-invalid")
      .removeClass("is-valid is-invalid");

    return this;
  };

  Validator.prototype.destroy = function () {
    this.reset();

    this.$element
      .removeAttr("novalidate")
      .removeData("bs.validator")
      .off(".bs.validator");

    this.$inputs.off(".bs.validator");

    this.options = null;
    this.validators = null;
    this.$element = null;
    this.$btn = null;
    this.$inputs = null;

    return this;
  };

  // VALIDATOR PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var options = $.extend(
        {},
        Validator.DEFAULTS,
        $this.data(),
        typeof option == "object" && option
      );
      var data = $this.data("bs.validator");

      if (!data && option == "destroy") return;
      if (!data)
        $this.data("bs.validator", (data = new Validator(this, options)));
      if (typeof option == "string") data[option]();
    });
  }

  var old = $.fn.validator;

  $.fn.validator = Plugin;
  $.fn.validator.Constructor = Validator;

  // VALIDATOR NO CONFLICT
  // =====================

  $.fn.validator.noConflict = function () {
    $.fn.validator = old;
    return this;
  };

  // VALIDATOR DATA-API
  // ==================

  $(window).on("load", function () {
    $('form[data-toggle="validator"]').each(function () {
      var $form = $(this);
      Plugin.call($form, $form.data());
    });
  });
})(jQuery);

/* Version: 1.0.7 - Last modified: 2018-07-18 17:21:21 */
String.prototype.simpleMaskStringCount = function (s1) {
  return (
    (this.length - this.replace(new RegExp(s1, "g"), "").length) / s1.length
  );
};

(function ($) {
  var defaults = {
    mask: "",
    nextInput: null,
    onComplete: null,
  };
  var objects = [];

  var methods = {
    init: function (options) {
      var opts = $.extend({}, defaults, options);

      return this.each(function () {
        $.fn.simpleMask.process($(this), opts);
      });
    },
    unmask: function () {
      return this.each(function () {
        $.fn.simpleMask.unmask(this);
      });
    },
  };

  $.fn.simpleMask = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );
    } else if (typeof methodOrOptions === "object" || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error(
        "Method " + methodOrOptions + " does not exist on jQuery.SimpleMask"
      );
    }
  };

  $.fn.simpleMask.makeId = function () {
    var text = "";
    var possible =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz0123456789";
    var pl = possible.length;
    for (var i = 0; i < 8; i++) {
      text += possible.charAt(Math.floor(Math.random() * pl));
    }
    return text;
  };

  $.fn.simpleMask._onComplete = function (p_arg) {
    var ids = typeof p_arg == "object" ? $(p_arg).attr("data-mask-ids") : p_arg;
    if (objects[ids].options.onComplete !== null) {
      objects[ids].options.onComplete.call(this, objects[ids]);
      $.fn.simpleMask._nextInput(ids);
    } else {
      $.fn.simpleMask._nextInput(ids);
    }
  };

  $.fn.simpleMask.nextOnTabIndex = function (element) {
    var $element = $(element);
    var get_next = false;
    var result = [];
    $element
      .closest("form")
      .find("input,select")
      .each(function (index) {
        var $current = $(this);
        if (get_next) {
          result = $current;
          return false;
        }

        var check = $current[0] == $element[0];
        if (check) {
          get_next = true;
        }
      });
    return result;
  };

  $.fn.simpleMask._nextInput = function (p_arg) {
    var ids = typeof p_arg == "object" ? $(p_arg).attr("data-mask-ids") : p_arg;
    if (objects[ids].options.nextInput !== null) {
      if (objects[ids].options.nextInput === true) {
        var nextelement = $.fn.simpleMask.nextOnTabIndex(objects[ids].element);
        if (nextelement.length > 0) {
          nextelement.select().focus();
        }
      } else if (objects[ids].options.nextInput.length > 0) {
        objects[ids].options.nextInput.select().focus();
      }
    }
  };

  $.fn.simpleMask.unmask = function (p_arg) {
    var ids = typeof p_arg == "object" ? $(p_arg).attr("data-mask-ids") : p_arg;

    $(objects[ids].element)
      .removeClass("input-masked")
      .removeAttr("data-mask-ids");
    if ($(objects[ids].element).attr("class") === "") {
      $(objects[ids].element).removeAttr("class");
    }

    $(document).off(
      "keyup.simpleMask change.simpleMask",
      'input[data-mask-ids="' + ids + '"]'
    );
    $(document).off("keydown.simpleMask", 'input[data-mask-ids="' + ids + '"]');
  };

  $.fn.simpleMask.isNumber = function (p_string) {
    return p_string.replace(/\D/g, "") !== "";
  };

  $.fn.simpleMask.onlyNumbers = function (p_string) {
    return p_string.replace(/\D/g, "");
  };

  $.fn.simpleMask.onlyNumbersLength = function (p_string) {
    return p_string.replace(/\D/g, "").length;
  };

  $.fn.simpleMask.applyMask = function (p_object, p_key) {
    var p_element = p_object.element;
    var html_element = $(p_element)[0];
    var caret_ini = html_element.selectionStart;
    var caret_end = html_element.selectionEnd;
    var old_value = p_object.oldvalue;
    var cur_value = $(p_element).val();
    var vrTemp = $.fn.simpleMask.onlyNumbers($(p_element).val());

    var p_mask = p_object.masks[0];
    var max_mask = p_object.masks[
      p_object.masks.length - 1
    ].simpleMaskStringCount("#");
    if (vrTemp.length > max_mask) {
      vrTemp = vrTemp.substr(0, max_mask);
    }
    var curr_length = vrTemp.length;
    for (var i in p_object.masks) {
      if (p_object.masks[i].simpleMaskStringCount("#") == curr_length) {
        p_mask = p_object.masks[i];
        break;
      }
    }

    if (vrTemp.length > 0) {
      vrTemp = vrTemp.trim();
      var result = p_mask;
      var l = vrTemp.length;

      for (var k = 0; k < l; k++) {
        result = result.replace("#", vrTemp.charAt(k));
      }

      var pos = result.indexOf("#");
      if (pos != -1) {
        result = result.substr(0, pos);
      }

      var ultimo = result.substr(result.length - 1, 1);
      if ($.fn.simpleMask.onlyNumbers(ultimo) === "") {
        result = result.substr(0, pos - 1);
      }

      var lastchar = result.substr(result.length - 1, 1);
      while (
        result.length > 0 &&
        $.fn.simpleMask.isNumber(lastchar) === false
      ) {
        result = result.substr(0, result.length - 1);
        lastchar = result.substr(result.length - 1, 1);
      }

      if (result != cur_value) {
        $(p_element).val(result);
      }
      if (result != old_value) {
        if (
          result.length == p_mask.length &&
          result.length <= caret_end &&
          result.length == p_object.maxlengthmask
        ) {
          if (Number.isInteger(p_key)) {
            $.fn.simpleMask._onComplete(p_element.attr("data-mask-ids"));
          }
        }
      }
    } else {
      $(p_element).val("");
    }

    p_object.oldvalue = $(p_element).val();
  };

  $.fn.simpleMask.process = function (p_elem, p_options) {
    var ids = $.fn.simpleMask.makeId();
    while (objects[ids] !== undefined) {
      ids = $.fn.simpleMask.makeId();
    }
    var comp = {};
    comp.element = p_elem;
    comp.options = p_options;
    comp.nextInput = p_options.nextInput;
    comp.onComplete = p_options.onComplete;
    comp.oldvalue = $(p_elem).val();

    var usemasks = [];
    if (typeof p_options.mask == "string") {
      usemasks = [p_options.mask];
    } else {
      usemasks = p_options.mask;
    }

    for (var k in usemasks) {
      switch (usemasks[k].toLowerCase()) {
        case "cpf":
          usemasks[k] = "###.###.###-##";
          break;
        case "cnpj":
          usemasks[k] = "##.###.###/####-##";
          break;
        case "cep":
          usemasks[k] = "#####-###";
          break;
        case "date":
        case "data":
          usemasks[k] = "##/##/####";
          break;
        case "telefone":
        case "tel":
          usemasks[k] = "####-####";
          break;
        case "telefone9":
        case "tel9":
          usemasks[k] = "####-####";
          usemasks.push("#####-####");
          break;
        case "ddd-telefone9":
        case "ddd-tel9":
          usemasks[k] = "(##) ####-####";
          usemasks.push("(##) #####-####");
          break;
      }
    }

    comp.masks = usemasks;
    comp.masks.sort(function (a, b) {
      return a.length - b.length;
    });
    comp.maxlengthmask = comp.masks[comp.masks.length - 1].length;

    objects[ids] = comp;
    p_elem.attr("data-mask-ids", ids).addClass("input-masked");

    $(document).on(
      "keyup.simpleMask change.simpleMask",
      'input[data-mask-ids="' + ids + '"]',
      function (e) {
        $.fn.simpleMask.applyMask(comp, parseInt(e.key));
      }
    );

    $(document).on("paste", 'input[data-mask-ids="' + ids + '"]', function (e) {
      var $element = $(this);
      setTimeout(function () {
        $element.keyup();
      }, 100);
    });

    $(document).on(
      "keydown.simpleMask",
      'input[data-mask-ids="' + ids + '"]',
      function (e) {
        if (!e.ctrlKey) {
          if (e.keyCode >= 65 && e.keyCode <= 90) {
            e.preventDefault();
          }
        }
      }
    );
    $.fn.simpleMask.applyMask(comp);
  };
})(jQuery);
